import { isSameBerlinDay, parseUtcTimestamp } from './timeUtils';
import { fmt } from './numberFormat';

/** Active-power registers of the SMGW archive (Bezug / Einspeisung). */
export const OBIS_IMPORT = '1-0:1.7.0';
export const OBIS_EXPORT = '1-0:2.7.0';

/** Power in W as "830 W" / "1,24 kW". */
export const formatPower = (powerW: number | undefined): string => {
  if (powerW === undefined) return '-';
  if (Math.abs(powerW) >= 1000) return `${fmt(powerW / 1000)} kW`;
  return `${fmt(powerW, 0)} W`;
};

/** Time of day HH:MM:SS of a backend instant; older than today with the date, so a days-old value does not read as today. */
export const formatTime = (timestamp: string | undefined): string => {
  if (!timestamp) return '-';
  const date = parseUtcTimestamp(timestamp);
  if (isNaN(date.getTime())) return '-';
  const time = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  return isSameBerlinDay(date, new Date())
    ? time
    : `${date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })} ${time}`;
};

/** Colour of a signed power: consumption blue, feed-in green, zero grey. */
export const powerColor = (powerW: number | undefined): string =>
  (powerW ?? 0) > 0 ? 'text-info-600 dark:text-info-400'
    : (powerW ?? 0) < 0 ? 'text-success-600 dark:text-success-400'
      : 'text-gray-400 dark:text-primary-400';
